import { useEffect, useRef } from 'react';

import { useChatMessageSocketSendEvents } from '../socketEvents';

type Props = {
  channelId?: string | null;
  enabled: boolean;
  flightRoomId?: string | null;
};

export const useEmitChatReadAllOnce = ({ channelId, enabled, flightRoomId }: Props) => {
  const { sendChatReadAllMessages } = useChatMessageSocketSendEvents();
  const lastActiveChannelRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled || !channelId || !flightRoomId) {
      lastActiveChannelRef.current = null;
      return;
    }
    if (lastActiveChannelRef.current === channelId) {
      return;
    }
    lastActiveChannelRef.current = channelId;
    sendChatReadAllMessages({ channelId, chatroomId: flightRoomId });
  }, [channelId, enabled, flightRoomId, sendChatReadAllMessages]);
};
